import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=4ea9681d&scoped=true&"
import script from "./NoData.vue?vue&type=script&lang=js&"
export * from "./NoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea9681d",
  null
  
)

export default component.exports